module.exports = __webpack_public_path__ + "media/images/vp/icon.task-2c08f5f20d4e4bdc1f6c2e1c6a3e13e1.svg";